import { FetchState, hasValue } from "../Models/Client/FetchState"
import { APIAppPlan } from "../Models/API/APIAppPlans"
import { useAppState } from "./useReduxState"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { getPlansMetadata } from "../Actions/API/AppInstance/AppInstanceActions"
import { useAppInstance } from "./useAppInstance"
import { Result } from "../Models/Utility/Result"
import { selectIsSysAdmin } from "../Helpers/Functions/Selectors/auth"

export function useAppPlansMetadata(appID: string): FetchState<APIAppPlan[]> {
    const dispatch = useDispatch()
    const instanceFetchState = useAppInstance(appID)
    const plansFetchState = useAppState(
        state => state.api.apps.plansMetadata[appID]
    )
    const isSysAdmin = useAppState(selectIsSysAdmin)

    useEffect(() => {
        if (plansFetchState === undefined) {
            dispatch(getPlansMetadata(appID))
        }
    }, [appID, dispatch, plansFetchState])

    return useMemo(() => {
        if (!hasValue(instanceFetchState)) {
            return instanceFetchState
        }

        if (!hasValue(plansFetchState) || isSysAdmin) {
            return plansFetchState
        }

        return Result.ok(
            plansFetchState.value.filter(
                plan =>
                    instanceFetchState.value.dpWorkflows?.includes(
                        plan.workflow
                    ) ?? false
            )
        )
    }, [plansFetchState, instanceFetchState, isSysAdmin])
}
